<template>
    <a-modal
        :visible="visible"
        :width="900"
        centered
        @cancel="handleCancel"
        :bodyStyle="{ padding: '10px 20px' }"
    >
        <template #title>
            <div class="cfg-head">
                
                <span class="ico">
                    <i class="fa-solid fa-calculator"></i>
                </span>

                <div class="cfg-head-text">
                    <div class="title">
                        Configurar algoritmo de sugestão
                    </div>

                    <div class="sub">
                        Defina como a quantidade sugerida de reposição é calculada para cada item.
                    </div>
                </div>

            </div>
        </template>
        <div class="algorithm-modal-content">

            <a-form layout="vertical" class="algorithm-form">
                <div class="algorithm-grid">


                    <div class="algorithm-section">
                        <div class="section-row">

                            <div class="section-icon">
                                <span class="material-symbols-outlined size-icon">
                                deployed_code
                                </span>
                            </div>

                            <div class="section-content">
                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Estoque</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Real</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Qual posição de estoque o cálculo deve subtrair da necessidade.
                                </div>

                                <a-radio-group
                                    v-model="form.estoque"
                                    class="algorithm-options"
                                >
                                    <a-button 
                                        v-for="(option, key) in estoqueOptions"
                                        :key="key"
                                        @click="form.estoque = key"
                                        :class="[
                                            'algorithm-option-button',
                                            { 'algorithm-option-button--active': form.estoque === key }
                                        ]"
                                    >
                                        <a-radio
                                            :key="key"
                                            :value="key"
                                        >
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                    info
                                    </span>
                                    {{ estoqueOptions[form.estoque].help }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="algorithm-section">
                        <div class="section-row">

                            <div class="section-icon">
                                <span class="material-symbols-outlined size-icon">
                                local_shipping
                                </span>
                            </div>

                            <div class="section-content">
                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Pendência</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Desconsiderar pendência</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Considerar pedidos de compra já em trânsito ao calcular a sugestão.
                                </div>

                                <a-radio-group
                                    v-model="form.pendencia"
                                    class="algorithm-options"
                                >
                                    <a-button 
                                        v-for="(option, key) in pendenciaOptions"
                                        :key="key"
                                        @click="form.pendencia = key"
                                        :class="[
                                            'algorithm-option-button',
                                            { 'algorithm-option-button--active': form.pendencia === key }
                                        ]"
                                    >
                                        <a-radio
                                            :key="key"
                                            :value="key"
                                        >
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                    info
                                    </span>
                                    {{ pendenciaOptions[form.pendencia].help }}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="algorithm-section">
                        <div class="section-row">

                            <div class="section-icon">
                                <span class="material-symbols-outlined size-icon">
                                schedule
                                </span>
                            </div>

                            <div class="section-content">
                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Cobertura</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Tempo entre compras</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Por quantos dias de demanda a sugestão deve cobrir o item.
                                </div>

                                <a-radio-group
                                    v-model="form.cobertura"
                                    class="algorithm-options"
                                >
                                    <a-button 
                                        v-for="(option, key) in coberturaOptions"
                                        :key="key"
                                        @click="form.cobertura = key"
                                        :class="[
                                            'algorithm-option-button',
                                            { 'algorithm-option-button--active': form.cobertura === key }
                                        ]"
                                    >
                                        <a-radio :value="key">
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                    info
                                    </span>
                                    {{ coberturaOptions[form.cobertura].help }}
                                </div>

                                <a-card size="small" v-if="form.cobertura === 'cobertura_fixa'">
                                    <div
                                        
                                        class="cover-input"
                                    >
                                        <label for="cob-dias" style="margin-bottom: 0; color: rgba(0,0,0,0.65)">Dias de cobertura</label>

                                        <div class="num-stepper">

                                            <a-input-number
                                                id="cob-dias"
                                                :min=1
                                                :max=365
                                                v-model.number="form.cobertura_dias"
                                            />

                                        </div>

                                        <span class="unit">dias</span>
                                    </div>
                                </a-card>
                            </div>
                        </div>
                    </div>

                    <div class="algorithm-section">
                        <div class="section-row">

                            <div class="section-icon">
                                <span class="material-symbols-outlined size-icon">
                                sync
                                </span>
                            </div>

                            <div class="section-content">
                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Giro</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Ponderado</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Janela de histórico usada para estimar a demanda média diária.
                                </div>

                                <a-radio-group
                                    v-model="form.giro"
                                    class="algorithm-options giro-options"
                                >
                                    <a-button 
                                        v-for="(option, key) in giroOptions"
                                        :key="key"
                                        @click="form.giro = key"
                                        :class="[
                                            'algorithm-option-button-days',
                                            { 'algorithm-option-button--active': form.giro === key }
                                        ]"
                                    >
                                        <a-radio
                                            :key="key"
                                            :value="key"
                                        >
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                    info
                                    </span>
                                    {{ giroOptions[form.giro].help }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!hiddenFields.includes('unidade')" class="algorithm-section-last">
                        <div class="section-row">

                            <div class="section-icon">
                                <i class="fa fa-boxes size-icon"></i>
                            </div>

                            <div class="section-content">

                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Unidade de compra</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Unidade</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Como a quantidade sugerida é agrupada em embalagens de compra.
                                </div>

                                <a-radio-group
                                    v-model="form.unidade"
                                    class="algorithm-options"
                                >
                                    <a-button 
                                        v-for="(option, key) in visibleUnidadeOptions"
                                        :key="key"
                                        @click="form.unidade = key"
                                        :class="[
                                            'algorithm-option-button',
                                            { 'algorithm-option-button--active': form.unidade === key }
                                        ]"
                                    >
                                        <a-radio
                                            :key="key"
                                            :value="key"
                                        >
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                    info
                                    </span>
                                    {{ unidadeOptions[form.unidade].help }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!hiddenFields.includes('exibicao')" class="algorithm-section-last">
                        <div class="section-row">

                            <div class="section-icon">
                                <span class="material-symbols-outlined size-icon">
                                    visibility
                                </span>
                            </div>

                            <div class="section-content">

                                <div class="algorithm-section-header">
                                    <div class="algorithm-title">
                                        <span>Exibição do resultado</span>
                                    </div>

                                    <span class="algorithm-default">
                                        Padrão: <strong>Somente com sugestão</strong>
                                    </span>
                                </div>

                                <div class="algorithm-description">
                                    Quais itens aparecem na lista depois que o algoritmo é aplicado.
                                </div>

                                <a-radio-group
                                    v-model="form.exibicao"
                                    class="algorithm-options"
                                >
                                    <a-button
                                        v-for="(option, key) in exibicaoOptions"
                                        :key="key"
                                        @click="form.exibicao = key"
                                        :class="[
                                            'algorithm-option-button',
                                            { 'algorithm-option-button--active': form.exibicao === key }
                                        ]"
                                    >
                                        <a-radio :value="key">
                                            {{ option.label }}
                                        </a-radio>
                                    </a-button>
                                </a-radio-group>

                                <div class="algorithm-help">
                                    <span class="material-symbols-outlined info-icon">
                                        info
                                    </span>

                                    {{ exibicaoOptions[form.exibicao].help }}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </a-form>
            
        </div>

        <template #footer>
            <div class="modal-footer">
                
                <a-button
                    type="link"
                    class="reset-btn"
                    @click="$emit('reset')"
                    :disabled="isDefaultFilters"
                >
                    <i class="fa-solid fa-sync"></i>
                    Redefinir padrões
                </a-button>

                <div class="footer-actions">
                    <a-button @click="$emit('close')">
                        Cancelar
                    </a-button>

                    <a-button type="primary" @click="$emit('save')">
                        Aplicar
                    </a-button>
                </div>

            </div>
        </template>
    </a-modal>
</template>

<script>

export default {
    name: "SuggestionAlgorithmModal",

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default: () => ({})
        },
        resetFilters: {
            type: Function,
        },
        hiddenFields: {
            type: Array,
            default: () => []
        },
        hiddenUnidadeOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultAlgorithmFilters: {
                estoque: 'real',
                pendencia: 'desconsiderar',
                cobertura: 'tempo_compra',
                cobertura_dias: 30,
                giro: 'ponderado',
                unidade: 'unidade',
                exibicao: 'todos'
            },
            estoqueOptions: {
                real: {
                    label: "Real",
                    help: "Usa a posição de estoque atual registrada no sistema."
                },
                estimado: {
                    label: "Estimado",
                    help: "Quantidade da última compra menos as vendas desde a data da última compra."
                },
                desconsiderar: {
                    label: "Desconsiderar",
                    help: "Ignora o estoque atual — a sugestão cobre toda a necessidade do período."
                }
            },
            pendenciaOptions: {
                desconsiderar: {
                    label: "Desconsiderar Pendência",
                    help: "Não abate pedidos de compra já em trânsito da quantidade sugerida."
                },
                considerar: {
                    label: "Considerar Pendência",
                    help: "Abate da sugestão os pedidos de compra já em trânsito."
                }
            },
            coberturaOptions: {
                tempo_compra: {
                    label: "Tempo entre Compras",
                    help: "Cálculo automático da periodicidade com que se compra esse item."
                },
                cobertura_fixa: {
                    label: "Cobertura fixa (dias)",
                    help: "Define uma cobertura fixa em dias independente do histórico."
                }
            },
            giroOptions: {
                ponderado: {
                    label: "Ponderado",
                    help: "Cálculo automático do giro baseado numa média ponderada entre todos os períodos de venda."
                },
                dias_7: {
                    label: "7 Dias",
                    help: "Demanda média diária dos últimos 7 dias."
                },
                dias_30: {
                    label: "30 Dias",
                    help: "Demanda média diária dos últimos 30 dias."
                },
                dias_90: {
                    label: "90 Dias",
                    help: "Demanda média diária dos últimos 90 dias."
                },
                dias_180: {
                    label: "180 Dias",
                    help: "Demanda média diária dos últimos 180 dias."
                },
            },
            unidadeOptions: {
                unidade: {
                    label: "Unidade",
                    help: "Sugestão em unidades individuais, sem agrupar em embalagens."
                },
                unidade_compra: {
                    label: "Unidade de Compra",
                    help: "Sugestão arredondada para múltiplos da embalagem de compra (ex.: fardo, caixa)."
                },
                ultima_compra: {
                    label: "Última Compra",
                    help: "Sugestão arredondada para o mesmo agrupamento usado na última compra."
                },
            },
            exibicaoOptions: {
                todos: {
                    label: "Todos os itens",
                    help: "Mostra todos os itens analisados, inclusive os sem sugestão de reposição."
                },
                sugestao: {
                    label: "Somente com sugestão",
                    help: "Oculta itens com quantidade sugerida zerada — a lista abre já enxuta, pronta para ação."
                },
            }
        };
    },

    methods: {
        handleReset() {
            this.$emit('reset');
        },
        submitAlgorithm() {
            const payload = {
                estoque: this.form.estoque,
                pendencia: this.form.pendencia,
                cobertura: this.form.cobertura,
                giro: this.form.giro,
                unidade: this.form.unidade,
                exibicao: this.form.exibicao
            };

            if (this.form.cobertura === 'cobertura_fixa') {
                payload.cobertura_dias = this.form.cobertura_dias;
            }

            this.$emit('submit', payload);
        },
        handleCancel() {
            this.$emit("close");
        },

        handleSave() {
            this.$emit("save");
        }
    },
    watch: {
        'form.cobertura'(val) {
            if (val !== 'cobertura_fixa') {
                this.form.cobertura_dias = 30;
            }
        }
    },

    computed: {
        isDefaultFilters() {
            const f = this.value;

            return Object.keys(this.defaultAlgorithmFilters)
                .filter((key) => !this.hiddenFields.includes(key))
                .every((key) => f[key] === this.defaultAlgorithmFilters[key]);
        },
        visibleUnidadeOptions() {
            return Object.fromEntries(
                Object.entries(this.unidadeOptions).filter(([key]) => !this.hiddenUnidadeOptions.includes(key))
            );
        },
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>

<style scoped>
.giro-options {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px;
}

.giro-options .algorithm-option-button-days {
    width: calc(33.333% - 6px) !important;
    flex: none !important;
    margin: 0 !important;
}
.algorithm-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.algorithm-section,
.algorithm-section-first,
.algorithm-section-last {
    width: 100%;
}

.algorithm-header {
    margin-bottom: 24px;

    h2 {
        margin-bottom: 8px;
        font-size: 22px;
        font-weight: 600;
    }

    p {
        color: rgba(0, 0, 0, .65);
        margin-bottom: 16px;
    }
}
.algorithm-card {
    margin-bottom: 16px;
}
.algorithm-radio-group {
    width: 100%;
}

.algorithm-option {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;

    padding: 14px 16px;
    margin-bottom: 12px;

    border: 1px solid #e8e8e8;
    border-radius: 8px;

    cursor: pointer;
    transition: .2s;

    &:hover {
        border-color: #1890ff;
    }

    &.active {
        border-color: #1890ff;
        background: #f0f8ff;
    }
}

.algorithm-option-content {
    flex: 1;
}

.algorithm-option-title {
    font-weight: 600;
    margin-bottom: 4px;
}

.algorithm-option-description {
    color: rgba(0,0,0,.45);
    font-size: 13px;
    line-height: 20px;
}
.algorithm-section {
    padding: 10px 0 10px 0;
    border-bottom: 1px solid #f0f0f0;
}
.algorithm-section-last {
    padding: 10px 0 10px 0;
}
.algorithm-section-first {
    padding: 10px 0 10px 0;
}

.algorithm-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.algorithm-title {
    display: flex;
    align-items: center;
    gap: 10px;

    font-size: 1rem;
    font-weight: 600;
}

.algorithm-description {
    color: #8c8c8c;
    margin-bottom: 6px;
}

.algorithm-options {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
}

.algorithm-options .ant-radio-button-wrapper {
    flex: 1;
    text-align: center;
}

.algorithm-help {
    margin-top: 10px;
    color: #666;
    font-size: 13px;
    display: flex;
    gap: 6px;
    align-items: center;
}

.algorithm-default {
    color: #999;
    font-size: 13px;
}
.algorithm-options {
    display: flex;
    width: 100%;
    gap: 8px;
}

.algorithm-options > .ant-btn {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.algorithm-option-button {
    flex: 1;
    border-radius: 8px;
    transition: all .2s ease;

    &:hover {
        border-color: #ff432d;
    }

    .ant-radio-wrapper {
        font-weight: 500;
        transition: all .2s ease;
    }
}

.algorithm-option-button-days {
    flex: 1;
    border-radius: 8px;
    transition: all .2s ease;
    width: 33%;

    &:hover {
        border-color: #ff432d;
    }

    .ant-radio-wrapper {
        font-weight: 500;
        transition: all .2s ease;
    }
}

.algorithm-option-button--active {
    background: #fff1f0;
    border-color: #ff432d;

    .ant-radio-wrapper {
        color: #ff432d;
        font-weight: 600;
    }

    .ant-radio-inner {
        border-color: #ff432d;
    }

    .ant-radio-checked .ant-radio-inner {
        background-color: #ff432d;
        border-color: #ff432d;
    }

    ::v-deep .ant-radio-inner {
        border-color: #ff432d;
    }

    ::v-deep .ant-radio-checked .ant-radio-inner {
        background-color: #ff432d;
        border-color: #ff432d;
    }

    ::v-deep .ant-radio-wrapper {
        color: #ff432d;
        font-weight: 600;
    }
    ::v-deep .ant-radio-checked .ant-radio-inner {
        border-color: #ff432d;
        background-color: #fff1f0;
    }

    ::v-deep .ant-radio-checked .ant-radio-inner::after {
        background-color: #ff432d;
    }
    ::v-deep .ant-radio-checked::after {
        border-color: #ff432d;
    }
}
::v-deep .ant-radio-checked .ant-radio-inner::after {
    background-color: #ff432d !important;
}

::v-deep .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none !important;
}

::v-deep .ant-radio:hover .ant-radio-inner,
::v-deep .ant-radio-input:focus + .ant-radio-inner {
    border-color: #ff432d !important;
}
.algorithm-option-button--active,
.algorithm-option-button--active:hover,
.algorithm-option-button--active:focus,
.algorithm-option-button--active:active {
    background: #fff1f0;
    border-color: #ff432d;
    color: #ff432d;
}
.algorithm-option-button--active::after {
    display: none;
}
.cover-input {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.cover-input label {
    font-weight: 500;
    min-width: 140px;
}

.num-stepper {
    display: flex;
    align-items: center;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    height: 32px;
}
.modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: none;
    padding: 0
}
::v-deep .ant-modal-footer {
    background: #FAFAFA !important;
}
.reset-btn {
    padding: 0;
    height: auto;
    color: rgba(0, 0, 0, 0.65);
}

.reset-btn:hover {
    color: #ff432d;
}
.reset-btn:focus,
.reset-btn:focus-visible {
    color: rgba(0, 0, 0, 0.65) !important;
    box-shadow: none !important;
    outline: none !important;
}
.cfg-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.cfg-head .ico {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 34px;
    height: 34px;

    background: #fff1f0;
    color: #ff432d;
    border-radius: 8px;

    font-size: 14px;
    line-height: 1;
    .fa-solid {
        margin: 0 !important;
    }
}

.cfg-head-text {
    flex: 1;
}

.cfg-head .title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
}

.cfg-head .sub {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 2px;
}

.cfg-head .close {
    background: transparent;
    border: none;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
    padding: 4px;
}

.cfg-head .close:hover {
    color: #ff432d;
}
.section-row {
    display: grid;
    grid-template-columns: 34px 1fr;
    gap: 12px;
    align-items: flex-start;
}
.section-icon {
    width: 24px;
    height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #555555;
    background: #F5F5F5;
    border-radius: 8px;

    position: sticky;
    top: 0;
    .fa-solid {
        margin: 0 !important;
    }
}
.section-content {
    display: flex;
    flex-direction: column;
}
.info-icon {
    color: #ff432d;
    font-size: 0.8rem;
}
.size-icon {
    font-size: .9rem;
}
</style>